import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';
import * as TYPES from './constants';
import {
  requestStudentAssessments,
  receiveStudentAssessments,
  handleStudentAssessmentsError,
} from './actions';
const initialState = {
  request: null,
  data: null,
  error: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_STUDENT_ASSESSMENTS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_STUDENT_ASSESSMENTS:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.STUDENT_ASSESSMENTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchStudentAssessments = student_uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestStudentAssessments());
  try {
    return fetch(
      `${API.student.student_assessment}?student_uuid=${student_uuid}`,
      config
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Api Fails');
      })
      .then(json => {
        if (json && json.assessment_result) {
          json.assessment_result = JSON.parse(json.assessment_result);
        }
        dispatch(receiveStudentAssessments(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleStudentAssessmentsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleStudentAssessmentsError(err));
  }
};
